import React from 'react';
import { Text, GenericSkeleton } from '@landr/maestro';

const Description = ({
    content,
    isLoading,
    isMobile,
}: {
    content: string;
    isLoading: boolean;
    isMobile: boolean;
}) => {
    if (isLoading) {
        return (
            <>
                <GenericSkeleton width="89%" height="16px" mt={2} mb={9} />
            </>
        );
    }

    return (
        <Text size={isMobile ? 'base' : 'lg'} contrast="low">
            {content}
        </Text>
    );
};

export default Description;
